export default "__VITE_ASSET__8ba3d475__"